module.exports = __webpack_public_path__ + "static/mmalandri-88ea6242f8904163e4ec5fd80f404a6e.jpg";